import { DynamicFieldInstruction } from './dynamic-field.instruction';
export class FilterFieldInstruction extends DynamicFieldInstruction {
  createComponentInputsMap(formGroup, formService) {
    if (this.config['label']) {
      throw new Error('Filter Instructions currently do not support "label" config field. Please use "placeholder" only.');
    }
    return super.createComponentInputsMap(formGroup, formService);
  }
}